import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'footnav',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/footnav')), 'footnav'),
      children: [
        {
          path: '/',
          name: 'workbench',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/workbench')), 'workbench')
        },
        {
          path: 'workbench',
          name: 'workbench',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/workbench')), 'workbench')
        },
        {
          path: '/mine',
          name: 'mine',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/mine')), 'mine')
        },
        {
          path: '/msgBoard',
          name: 'msgBoard',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgBoard')), 'msgBoard')
        },
        {
          path: '/footnav',
          name: 'footnav',
          component: resolve => require.ensure([], () => resolve(require('@/public/home/footnav')), 'footnav')
        }
      ]
    },
    {
      path: '/ministersPatrolList',
      name: 'ministersPatrolList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/ministersPatrol/ministersPatrolList')), 'ministersPatrolList')
    },
    {
      path: '/addMinistersPatrol',
      name: 'addMinistersPatrol',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/ministersPatrol/addMinistersPatrol')), 'addMinistersPatrol')
    },
    {
      path: '/patrolRecord',
      name: 'patrolRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/ministersPatrol/patrolRecord')), 'patrolRecord')
    },
    {
      path: '/project',
      name: 'project',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/project')), 'project')
    },
    {
      path: '/projectSetting',
      name: 'projectSetting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectSetting')), 'projectSetting')
    },
    {
      path: '/fileTemp',
      name: 'fileTemp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/fileTemp')), 'fileTemp')
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectDetail')), 'projectDetail')
    },
    {
      path: '/editProjectDetail',
      name: 'editProjectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/editProjectDetail')), 'editProjectDetail')
    },
    {
      path: '/projectProcess',
      name: 'projectProcess',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectProcess')), 'projectProcess')
    },
    {
      path: '/projectProcessCheck',
      name: 'projectProcessCheck',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectProcessCheck')), 'projectProcessCheck')
    },
    {
      path: '/projectProcessCheckDetail',
      name: 'projectProcessCheckDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectProcessCheckDetail')), 'projectProcessCheckDetail')
    },
    {
      path: '/projectInventory',
      name: 'projectInventory',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectInventory')), 'projectInventory')
    },
    {
      path: '/goodsFeedBack',
      name: 'goodsFeedBack',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/goodsFeedBack')), 'goodsFeedBack')
    },
    {
      path: '/goodsFeedBackSelect',
      name: 'goodsFeedBackSelect',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/goodsFeedBackSelect')), 'goodsFeedBackSelect')
    },
    {
      path: '/projectLost',
      name: 'projectLost',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/projectLost')), 'projectLost')
    },
    {
      path: '/projectInventoryMore',
      name: 'projectInventoryMore',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/projectInventoryMore')), 'projectInventoryMore')
    },
    {
      path: '/giftGivingRecord',
      name: 'giftGivingRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/giftGivingRecord')), 'giftGivingRecord')
    },
    {
      path: '/proprietorDetail',
      name: 'proprietorDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorDetail')), 'proprietorDetail')
    },
    {
      path: '/editProprietorDetail',
      name: 'editProprietorDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/editProprietorDetail')), 'editProprietorDetail')
    },
    {
      path: '/proprietorFollowRecords',
      name: 'proprietorFollowRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorFollowRecords')), 'proprietorFollowRecords')
    },
    {
      path: '/proprietorFollowRecords2',
      name: 'proprietorFollowRecords2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorFollowRecords2')), 'proprietorFollowRecords2')
    },
    {
      path: '/proprietorFollowRecordsDetail',
      name: 'proprietorFollowRecordsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorFollowRecordsDetail')), 'proprietorFollowRecordsDetail')
    },
    {
      path: '/proprietorTagAdd',
      name: 'proprietorTagAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorTagAdd')), 'proprietorTagAdd')
    },
    {
      path: '/proprietorTagAdd2',
      name: 'proprietorTagAdd2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorTagAdd2')), 'proprietorTagAdd2')
    },
    {
      path: '/labelFiltering',
      name: 'labelFiltering',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/labelFiltering')), 'labelFiltering')
    },
    {
      path: '/giveGifts',
      name: 'giveGifts',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/gift/giveGifts')), 'giveGifts')
    },
    {
      path: '/selectGift',
      name: 'selectGift',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/gift/selectGift')), 'selectGift')
    },
    {
      path: '/serviceFee',
      name: 'serviceFee',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/serviceFee')), 'serviceFee')
    },
    {
      path: '/paymentList',
      name: 'paymentList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/payment/paymentList')), 'paymentList')
    },
    {
      path: '/paymentDetail',
      name: 'paymentDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/payment/paymentDetail')), 'paymentDetail')
    },
    {
      path: '/paymentDetailnew',
      name: 'paymentDetailnew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/payment/paymentDetailnew')), 'paymentDetailnew')
    },
    {
      path: '/callRecords',
      name: 'callRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/callRecords')), 'callRecords')
    },
    {
      path: '/addServiceFee',
      name: 'addServiceFee',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/addServiceFee')), 'addServiceFee')
    },
    {
      path: '/serviceFeeDetail',
      name: 'serviceFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/serviceFeeDetail')), 'serviceFeeDetail')
    },
    {
      path: '/serviceFeeDetailNew',
      name: 'serviceFeeDetailNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/serviceFeeDetailNew')), 'serviceFeeDetailNew')
    },
    {
      path: '/proprieorRefund',
      name: 'proprieorRefund',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprieorRefund')), 'proprieorRefund')
    },
    {
      path: '/sign',
      name: 'sign',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/sign')), 'sign')
    },
    {
      path: '/giftsAfterSignList',
      name: 'giftsAfterSignList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/giftsAfterSignList')), 'giftsAfterSignList')
    },
    {
      path: '/giftsAfterSignDetail',
      name: 'giftsAfterSignDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/giftsAfterSignDetail')), 'giftsAfterSignDetail')
    },
    {
      path: '/giftsAfterSignRecord',
      name: 'giftsAfterSignRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/giftsAfterSignRecord')), 'giftsAfterSignRecord')
    },
    {
      path: '/addSign',
      name: 'addSign',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/addSign')), 'addSign')
    },
    {
      path: '/signDetail',
      name: 'signDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/signDetail')), 'signDetail')
    },
    {
      path: '/signDetailNew',
      name: 'signDetailNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/signDetailNew')), 'signDetailNew')
    },
    {
      path: '/editSign',
      name: 'editSign',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/editSign')), 'editSign')
    },
    {
      path: '/signList',
      name: 'signList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/signList')), 'signList')
    },
    {
      path: '/proprietorlist',
      name: 'proprietorlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorlist')), 'proprietorlist')
    },
    {
      path: '/editRecord',
      name: 'editRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/editRecord')), 'editRecord')
    },
    {
      path: '/projectUpdate',
      name: 'projectUpdate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectUpdate')), 'projectUpdate')
    },
    {
      path: '/parkingplacelist',
      name: 'parkingplacelist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplacelist')), 'parkingplacelist')
    },
    {
      path: '/parkingVisualization',
      name: 'parkingVisualization',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingVisualization')), 'parkingVisualization')
    },
    {
      path: '/parkingVisualizaDetail',
      name: 'parkingVisualizaDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingVisualizaDetail')), 'parkingVisualizaDetail')
    },
    {
      path: '/scrapParkingPlaceList',
      name: 'scrapParkingPlaceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/scrapParkingPlaceList')), 'scrapParkingPlaceList')
    },
    {
      path: '/parkingplaceview',
      name: 'parkingplaceview',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplaceview')), 'parkingplaceview')
    },
    {
      path: '/parkingplaceedit',
      name: 'parkingplaceedit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplaceedit')), 'parkingplaceedit')
    },
    {
      path: '/carBrandList',
      name: 'carBrandList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/carBrandList')), 'carBrandList')
    },
    {
      path: '/parkingplaceAdd',
      name: 'parkingplaceAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplaceAdd')), 'parkingplaceAdd')
    },
    {
      path: '/addlable',
      name: 'addlable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/addlable')), 'addlable')
    },
    {
      path: '/waitFollowUp',
      name: 'waitFollowUp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/waiting/waitFollowUp')), 'waitFollowUp')
    },
    {
      path: '/waitReceive',
      name: 'waitReceive',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/waiting/waitReceive')), 'waitReceive')
    },
    {
      path: '/proprietorFollowRecordsEdit',
      name: 'proprietorFollowRecordsEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorFollowRecordsEdit')), 'proprietorFollowRecordsEdit')
    },
    {
      path: '/xiaodingStatistics',
      name: 'xiaodingStatistics',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/xiaodingStatistics')), 'xiaodingStatistics')
    },
    {
      path: '/auditList',
      name: 'auditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/auditList')), 'auditList')
    },
    {
      path: '/auditListNew',
      name: 'auditListNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/auditListNew')), 'auditListNew')
    },
    {
      path: '/distributionList',
      name: 'distributionList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/distribution/distributionList')), 'distributionList')
    },
    {
      path: '/distributionDetail',
      name: 'distributionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/distribution/distributionDetail')), 'distributionDetail')
    },
    {
      path: '/managerTeam',
      name: 'managerTeam',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/managerTeam')), 'managerTeam')
    },
    {
      path: '/managerTeam2',
      name: 'managerTeam2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/managerTeam2')), 'managerTeam2')
    },
    {
      path: '/managerTeamChange',
      name: 'managerTeamChange',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/managerTeamChange')), 'managerTeamChange')
    },
    {
      path: '/managerPerson',
      name: 'managerPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/managerPerson')), 'managerPerson')
    },
    {
      path: '/depositList',
      name: 'depositList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/depositList')), 'depositList')
    },
    {
      path: '/adjustPersonnel',
      name: 'adjustPersonnel',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/distribution/adjustPersonnel')), 'adjustPersonnel')
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/userInfo')), 'userInfo')
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/updatePassword')), 'updatePassword')
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedback')), 'feedback')
    },
    {
      path: '/borrowingRecords',
      name: 'borrowingRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/borrowingRecords')), 'borrowingRecords')
    },
    {
      path: '/contractBorrowing',
      name: 'contractBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/contractBorrowing')), 'contractBorrowing')
    },
    {
      path: '/articleBorrowing',
      name: 'articleBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/articleBorrowing')), 'articleBorrowing')
    },
    {
      path: '/addBorrowing',
      name: 'addBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/addBorrowing')), 'addBorrowing')
    },
    {
      path: '/receiptBorrowing',
      name: 'receiptBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/receiptBorrowing')), 'receiptBorrowing')
    },
    {
      path: '/initiateReturn',
      name: 'initiateReturn',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/initiateReturn')), 'initiateReturn')
    },
    {
      path: '/officialSealBorrowing',
      name: 'officialSealBorrowing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/officialSealBorrowing')), 'officialSealBorrowing')
    },
    {
      path: '/myMaster',
      name: 'myMaster',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/myMaster')), 'myMaster')
    },
    {
      path: '/dailyRecord',
      name: 'dailyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecord')), 'dailyRecord')
    },
    {
      path: '/logComments',
      name: 'logComments',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/logComments')), 'logComments')
    },
    {
      path: '/dailyRecordAdd',
      name: 'dailyRecordAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordAdd')), 'dailyRecordAdd')
    },
    {
      path: '/selectSpaceTime',
      name: 'selectSpaceTime',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/selectSpaceTime')), 'selectSpaceTime')
    },
    {
      path: '/dailyRecordAdd2',
      name: 'dailyRecordAdd2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordAdd2')), 'dailyRecordAdd2')
    },
    {
      path: '/myDailyRecord',
      name: 'myDailyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/myDailyRecord')), 'myDailyRecord')
    },
    {
      path: '/dailyRecordView',
      name: 'dailyRecordView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordView')), 'dailyRecordView')
    }, ,
    {
      path: '/dailyRecordView2',
      name: 'dailyRecordView2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/dailyRecordView2')), 'dailyRecordView2')
    },
    {
      path: '/followUpList',
      name: 'followUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/followUpList')), 'followUpList')
    },
    {
      path: '/followUpAllList',
      name: 'followUpAllList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/followUpAllList')), 'followUpAllList')
    },
    {
      path: '/auditRecord',
      name: 'auditRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/auditRecord')), 'auditRecord')
    },
    {
      path: '/addEntrance',
      name: 'addEntrance',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/addEntrance')), 'addEntrance')
    },
    {
      path: '/parkingplaceYXlist',
      name: 'parkingplaceYXlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplaceYXlist')), 'parkingplaceYXlist')
    },
    {
      path: '/parkingplaceYXlist2',
      name: 'parkingplaceYXlist2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/parkingplaceYXlist2')), 'parkingplaceYXlist2')
    },
    {
      path: '/goodNewAdd',
      name: 'goodNewAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodNews/goodNewAdd')), 'goodNewAdd')
    },
    {
      path: '/depositGoodNewImg',
      name: 'depositGoodNewImg',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodNews/depositGoodNewImg')), 'depositGoodNewImg')
    },
    {
      path: '/goodNewImg',
      name: 'goodNewImg',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodNews/goodNewImg')), 'goodNewImg')
    },
    {
      path: '/invitationImg',
      name: 'invitationImg',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodNews/invitationImg')), 'invitationImg')
    },
    {
      path: '/thanksImg',
      name: 'thanksImg',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodNews/thanksImg')), 'thanksImg')
    },
    {
      path: '/setInfo',
      name: 'setInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/setInfo')), 'setInfo')
    },
    {
      path: '/auditAllot',
      name: 'auditAllot',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/auditAllot')), 'auditAllot')
    },
    {
      path: '/setReviewer',
      name: 'setReviewer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dailyRecord/setReviewer')), 'setReviewer')
    },
    {
      path: '/managerGiveGifts',
      name: 'managerGiveGifts',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/managerGiveGifts')), 'managerGiveGifts')
    },
    {
      path: '/statisticsDetail',
      name: 'statisticsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/statisticsDetail')), 'statisticsDetail')
    },
    {
      path: '/analysisData',
      name: 'analysisData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/analysisData')), 'analysisData')
    },
    {
      path: '/bankListConp',
      name: 'bankListConp',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/widget/bankListConp')), 'bankListConp')
    },
    {
      path: '/integralRule',
      name: 'integralRule',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/widget/integralRule')), 'integralRule')
    },
    {
      path: '/serviceFeeChangeLog',
      name: 'serviceFeeChangeLog',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/serviceFeeChangeLog')), 'serviceFeeChangeLog')
    },
    {
      path: '/addTag',
      name: 'addTag',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/tag/addTag')), 'addTag')
    },
    {
      path: '/callRecordsForStaff',
      name: 'callRecordsForStaff',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/callRecordsForStaff')), 'callRecordsForStaff')
    },
    {
      path: '/callRecordsForStaffAll',
      name: 'callRecordsForStaffAll',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/callRecordsForStaffAll')), 'callRecordsForStaffAll')
    },
    {
      path: '/fileboard',
      name: 'fileboard',
      component: resolve => require.ensure([], () => resolve(require('@/components/fileboard')), 'fileboard')
    },
    {
      path: '/signedList',
      name: 'signedList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/signedList')), 'signedList')
    },
    {
      path: '/serviceedList',
      name: 'serviceedList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/serviceedList')), 'serviceedList')
    },
    {
      path: '/msgList',
      name: 'msgList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgList')), 'msgList')
    },
    {
      path: '/msgNotice',
      name: 'msgNotice',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgNotice')), 'msgNotice')
    },
    {
      path: '/propagandaGift',
      name: 'propagandaGift',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/propagandaGift')), 'propagandaGift')
    },
    {
      path: '/giftDetails',
      name: 'giftDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/gift/giftDetails')), 'giftDetails')
    },
    {
      path: '/msgListDetail',
      name: 'msgListDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/msgListDetail')), 'msgListDetail')
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/noticeList')), 'noticeList')
    },
    {
      path: '/feedbackList',
      name: 'feedbackList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedbackList')), 'feedbackList')
    },
    {
      path: '/feedbackDetail',
      name: 'feedbackDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/feedbackDetail')), 'feedbackDetail')
    },
    {
      path: '/valueCaseStudy',
      name: 'valueCaseStudy',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/valueCaseStudy')), 'valueCaseStudy')
    },
    {
      path: '/scoreRulePage',
      name: 'scoreRulePage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/scoreRulePage')), 'scoreRulePage')
    },
    {
      path: '/integralDetail',
      name: 'integralDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/integralDetail')), 'integralDetail')
    },
    {
      path: '/withdrawalList',
      name: 'withdrawalList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/withdrawalList')), 'withdrawalList')
    },
    {
      path: '/giftCheckList',
      name: 'giftCheckList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/giftCheckList')), 'giftCheckList')
    },
    {
      path: '/auditProjectGiftPlant',
      name: 'auditProjectGiftPlant',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/auditProjectGiftPlant')), 'auditProjectGiftPlant')
    },
    {
      path: '/withdrawalDetail',
      name: 'withdrawalDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/withdrawalDetail')), 'withdrawalDetail')
    },
    {
      path: '/outputValue',
      name: 'outputValue',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/outputValue')), 'outputValue')
    },
    {
      path: '/outputValueList',
      name: 'outputValueList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/outputValueList')), 'outputValueList')
    },
    {
      path: '/waitVerifyService',
      name: 'waitVerifyService',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/waiting/waitVerifyService')), 'waitVerifyService')
    },
    {
      path: '/repairService',
      name: 'repairService',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/repairService')), 'repairService')
    },
    {
      path: '/submitBeOverdueFollowup',
      name: 'submitBeOverdueFollowup',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/submitBeOverdueFollowup/submitBeOverdueFollowup')), 'submitBeOverdueFollowup')
    },
    {
      path: '/submitBeOverdueFollowupRecord',
      name: 'submitBeOverdueFollowupRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/submitBeOverdueFollowup/submitBeOverdueFollowupRecord')), 'submitBeOverdueFollowupRecord')
    },
    {
      path: '/scoreType',
      name: 'scoreType',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/scoreType')), 'scoreType')
    },
    {
      path: '/score',
      name: 'score',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/score')), 'score')
    },
    {
      path: '/anonymousLetter',
      name: 'anonymousLetter',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/anonymousLetter/anonymousLetter')), 'anonymousLetter')
    },
    {
      path: '/anonymousList',
      name: 'anonymousList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/anonymousLetter/anonymousList')), 'anonymousList')
    },
    {
      path: '/allPersonList',
      name: 'allPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/allPersonList')), 'allPersonList')
    },
    {
      path: '/recordScoreList',
      name: 'recordScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/recordScoreList')), 'recordScoreList')
    },
    {
      path: '/scoreView',
      name: 'scoreView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/scoreView')), 'scoreView')
    },
    {
      path: '/assists',
      name: 'assists',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/assist/assists')), 'assists')
    },
    {
      path: '/assistsFollowList',
      name: 'assistsFollowList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/assist/assistsFollowList')), 'assistsFollowList')
    },
    {
      path: '/myAssistsList',
      name: 'myAssistsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/assist/myAssistsList')), 'myAssistsList')
    },
    {
      path: '/refundList',
      name: 'refundList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/refundList')), 'refundList')
    },
    {
      path: '/refundAudit',
      name: 'refundAudit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/refundAudit')), 'refundAudit')
    },
    {
      path: '/scoringRecord',
      name: 'scoringRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/scoringRecord')), 'scoringRecord')
    },
    {
      path: '/editSignEx',
      name: 'editSignEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/editSignEx')), 'editSignEx')
    },
    {
      path: '/punchClock',
      name: 'punchClock',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/punchClock')), 'editSignEx')
    },
    {
      path: '/myPunchClock',
      name: 'myPunchClock',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/myPunchClock')), 'editSignEx')
    },
    {
      path: '/subsequentSigning',
      name: 'subsequentSigning',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/subsequentSigning')), 'editSignEx')
    },
    {
      path: '/uploadFilePage',
      name: 'uploadFilePage',
      component: resolve => require.ensure([], () => resolve(require('@/components/uploadFilePage')), 'uploadFilePage')
    },
    {
      path: '/punchClockStatistics',
      name: 'punchClockStatistics',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/punchClockStatistics')), 'editSignEx')
    },
    {
      path: '/inventoryRecord',
      name: 'inventoryRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/inventoryRecord')), 'inventoryRecord')
    },
    {
      path: '/batchGift',
      name: 'batchGift',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/sign/batchGift')), 'batchGift')
    },
    {
      path: '/projectProcessChild',
      name: 'projectProcessChild',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectProcessChild')), 'projectProcessChild')
    },
    {
      path: '/projectGiftPlant',
      name: 'projectGiftPlant',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectGiftPlant')), 'projectGiftPlant')
    },
    {
      path: '/videoCourseList',
      name: 'videoCourseList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/videoCourseList')), 'videoCourseList')
    },
    {
      path: '/videoCourse',
      name: 'videoCourse',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/videoCourse')), 'videoCourse')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/privacy')), 'privacy')
    },
    {
      path: '/serviceNotSign',
      name: 'serviceNotSign',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/serviceNotSign')), 'serviceNotSign')
    },
    {
      path: '/serviceNotSignList',
      name: 'serviceNotSignList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/serviceNotSignList')), 'serviceNotSignList')
    },
    {
      path: '/mailList',
      name: 'mailList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/mailList')), 'mailList')
    },
    {
      path: '/employeeDetail',
      name: 'employeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/employeeDetail')), 'employeeDetail')
    },
    {
      path: '/historicalProject',
      name: 'historicalProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/historicalProject')), 'historicalProject')
    },
    {
      path: '/selfProjectList',
      name: 'selfProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/selfProjectList')), 'selfProjectList')
    },
    {
      path: '/transferRecord',
      name: 'transferRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/roster/transferRecord')), 'transferRecord')
    },
    {
      path: '/dataFee',
      name: 'dataFee',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/dataFee')), 'dataFee')
    },
    {
      path: '/purchasedParkingSpace',
      name: 'purchasedParkingSpace',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/purchasedParkingSpace')), 'purchasedParkingSpace')
    },
    {
      path: '/purchasedParkingDetail',
      name: 'purchasedParkingDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/purchasedParkingDetail')), 'purchasedParkingDetail')
    },
    {
      path: '/proprietorLabelRecord',
      name: 'proprietorLabelRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorLabelRecord')), 'proprietorLabelRecord')
    },
    {
      path: '/reviewedRecommenderList',
      name: 'reviewedRecommenderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/reviewedRecommender/reviewedRecommenderList')), 'reviewedRecommenderList')
    },
    {
      path: '/reviewedRecommenderDetail',
      name: 'reviewedRecommenderDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/reviewedRecommender/reviewedRecommenderDetail')), 'reviewedRecommenderDetail')
    },
    {
      path: '/cashCollection',
      name: 'cashCollection',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/cashCollection')), 'cashCollection')
    },
    {
      path: '/interviewRecordList',
      name: 'interviewRecordList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewRecordList')), 'interviewRecordList')
    },
    {
      path: '/interviewDetail',
      name: 'interviewDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interviewRecording/interviewDetail')), 'interviewDetail')
    },
    {
      path: '/cashCollectionDetail',
      name: 'cashCollectionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionDetail')), 'cashCollectionDetail')
    },
    {
      path: '/cashCollectionSupManagerList',
      name: 'cashCollectionSupManagerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionSupManagerList')), 'cashCollectionSupManagerList')
    },
    {
      path: '/cashCollectionManager',
      name: 'cashCollectionManager',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionManager')), 'cashCollectionManager')
    },
    {
      path: '/cashCollectionManagerList',
      name: 'cashCollectionManagerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionManagerList')), 'cashCollectionManagerList')
    },
    {
      path: '/cashCollectionSupManagerWait',
      name: 'cashCollectionSupManagerWait',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionSupManagerWait')), 'cashCollectionSupManagerWait')
    },
    {
      path: '/cashCollocetionManagerTransmitList',
      name: 'cashCollocetionManagerTransmitList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollocetionManagerTransmitList')), 'cashCollocetionManagerTransmitList')
    },
    {
      path: '/cashCollocetionManagerTransmitWait',
      name: 'cashCollocetionManagerTransmitWait',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollocetionManagerTransmitWait')), 'cashCollocetionManagerTransmitWait')
    },
    {
      path: '/cashTransferRecordV2',
      name: 'cashTransferRecordV2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashTransferRecord')), 'cashTransferRecord')
    },
    {
      path: '/cashTransfer',
      name: 'cashTransfer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/cashTransfer')), 'cashTransfer')
    },
    {
      path: '/cashTransfer2',
      name: 'cashTransfer2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/cashTransfer2')), 'cashTransfer2')
    },
    {
      path: '/cashTransferRecord',
      name: 'cashTransferRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/cashTransferRecord')), 'cashTransferRecord')
    },
    {
      path: '/cashTransferDetail',
      name: 'cashTransferDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/cashTransferDetail')), 'cashTransferDetail')
    },
    {
      path: '/numberTransactions',
      name: 'numberTransactions',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollection/numberTransactions')), 'numberTransactions')
    },
    {
      path: '/cashCollectionV2',
      name: 'cashCollectionV2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionV2')), 'cashCollectionV2')
    },
    {
      path: '/cashTransferV2',
      name: 'cashTransferV2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashTransferV2')), 'cashTransferV2')
    },
    {
      path: '/cashCollectionWait',
      name: 'cashCollectionWait',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/cashCollectionV2/cashCollectionWait')), 'cashCollectionWait')
    },
    {
      path: '/applyBeOverdue',
      name: 'applyBeOverdue',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/applyBeOverdue')), 'applyBeOverdue')
    },
    {
      path: '/auditServiceNotSignList',
      name: 'auditServiceNotSignList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/auditServiceNotSignList')), 'auditServiceNotSignList')
    },
    {
      path: '/salesList',
      name: 'salesList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/salesList')), 'salesList')
    },
    {
      path: '/auditServiceNotSign',
      name: 'auditServiceNotSign',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/statistics/auditServiceNotSign')), 'auditServiceNotSign')
    },
    {
      path: '/itemConfirmation',
      name: 'itemConfirmation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/itemConfirmation')), 'itemConfirmation')
    },
    {
      path: '/projectCheckList',
      name: 'projectCheckList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/projectCheckList')), 'projectCheckList')
    },
    {
      path: '/inventoryList',
      name: 'inventoryList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/inventoryList')), 'inventoryList')
    },
    {
      path: '/inventoryCheck',
      name: 'inventoryCheck',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/inventoryCheck')), 'inventoryCheck')
    },
    {
      path: '/inventorySecondCheck',
      name: 'inventorySecondCheck',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/inventorySecondCheck')), 'inventorySecondCheck')
    },
    {
      path: '/inventoryLogList',
      name: 'inventoryLogList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/inventoryLogList')), 'inventoryLogList')
    },
    {
      path: '/personalFixedAssets',
      name: 'personalFixedAssets',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventory/personalFixedAssets')), 'personalFixedAssets')
    },
    {
      path: '/objectAdd',
      name: 'objectAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/objectAdd')), 'objectAdd')
    },
    {
      path: '/projectPersonList',
      name: 'projectPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/projectPersonList')), 'projectPersonList')
    },
    {
      path: '/isObjectSecondSure',
      name: 'isObjectSecondSure',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/isObjectSecondSure')), 'isObjectSecondSure')
    },
    {
      path: '/isNoObjectSecondSure',
      name: 'isNoObjectSecondSure',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/isNoObjectSecondSure')), 'isNoObjectSecondSure')
    },
    {
      path: '/objectHistory',
      name: 'objectHistory',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/objectHistory')), 'objectHistory')
    },
    {
      path: '/dailyReport',
      name: 'dailyReport',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/dailyReport')), 'dailyReport')
    },
    {
      path: '/targetStatistics',
      name: 'targetStatistics',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/object/targetStatistics')), 'targetStatistics')
    },

    // 商城积分相关
    {
      path: '/mallCoinsNotIssued',
      name: 'mallCoinsNotIssued',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mallCurrency/mallCoinsNotIssued')), 'mallCoinsNotIssued')
    },
    {
      path: '/mallCurrencyRecord',
      name: 'mallCurrencyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mallCurrency/mallCurrencyRecord')), 'mallCurrencyRecord')
    },
    {
      path: '/preferentialConditionsList',
      name: 'preferentialConditionsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mallCurrency/preferentialConditionsList')), 'preferentialConditionsList')
    },
    {
      path: '/preferentialConditions',
      name: 'preferentialConditions',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mallCurrency/preferentialConditions')), 'preferentialConditions')
    },
    {
      path: '/preferentialSetting',
      name: 'preferentialSetting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mallCurrency/preferentialSetting')), 'preferentialSetting')
    },
    {
      path: '/businessCollegeList',
      name: 'businessCollegeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/businessCollegeList')), 'businessCollegeList')
    },
    {
      path: '/salaryList',
      name: 'salaryList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/salaryList')), 'salaryList')
    },
    {
      path: '/salaryDetail',
      name: 'salaryDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/salaryDetail')), 'salaryDetail')
    },
    {
      path: '/salaryViewHome',
      name: 'salaryViewHome',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/salaryViewHome')), 'salaryViewHome')
    },
    {
      path: '/summaryTable',
      name: 'summaryTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable')), 'summaryTable')
    },
    {
      path: '/summaryTable2',
      name: 'summaryTable2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable2')), 'summaryTable2')
    },
    {
      path: '/updateSummaryTable',
      name: 'updateSummaryTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/updateSummaryTable')), 'updateSummaryTable')
    },
    {
      path: '/projectStall',
      name: 'projectStall',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectStall')), 'projectStall')
    },
    {
      path: '/businessCollegeContent',
      name: 'businessCollegeContent',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/businessCollegeContent')), 'businessCollegeContent')
    },
    //OA 后续需更换路径
    {
      path: '/oaPending',
      name: 'oaPending',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaPending')), 'oaPending')
    },
    {
      path: '/oaCollectionAccount',
      name: 'oaCollectionAccount',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaCollectionAccount')), 'oaCollectionAccount')
    },
    {
      path: '/oaCollectionAccountDetail',
      name: 'oaCollectionAccountDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaCollectionAccountDetail')), 'oaCollectionAccountDetail')
    },
    {
      path: '/paymentApplication',
      name: 'paymentApplication',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/paymentApplication')), 'paymentApplication')
    },
    {
      path: '/dailyApply',
      name: 'dailyApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/dailyApply')), 'dailyApply')
    },
    {
      path: '/flowPathView',
      name: 'flowPathView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/flowPathView')), 'flowPathView')
    },
    {
      path: '/reimbursementProjectList',
      name: 'reimbursementProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/reimbursementProjectList')), 'reimbursementProjectList')
    },
    {
      path: '/oaHome',
      name: 'oaHome',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaHome')), 'oaHome')
    },
    {
      path: '/paymentApplicationDetail',
      name: 'paymentApplicationDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/paymentApplicationDetail')), 'paymentApplicationDetail')
    },
    {
      path: '/purchase',
      name: 'purchase',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/purchase')), 'purchase')
    },
    {
      path: '/logisticsDetail',
      name: 'logisticsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/logisticsDetail')), 'logisticsDetail')
    },
    {
      path: '/purchaseGoods',
      name: 'purchaseGoods',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/purchaseGoods')), 'purchaseGoods')
    },
    {
      path: '/oaLaunch',
      name: 'oaLaunch',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaLaunch')), 'oaLaunch')
    },
    {
      path: '/oaReceive',
      name: 'oaReceive',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaReceive')), 'oaReceive')
    },
    {
      path: '/dailyApplyAuditOrView',
      name: 'dailyApplyAuditOrView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/dailyApplyAuditOrView')), 'dailyApplyAuditOrView')
    },
    {
      path: '/proprietorTagHistory',
      name: 'proprietorTagHistory',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/proprietorTagHistory')), 'proprietorTagHistory')
    },
    {
      path: '/oaMakeCopy',
      name: 'oaMakeCopy',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/oaMakeCopy')), 'oaMakeCopy')
    },
    {
      path: '/pressForMoneyList',
      name: 'pressForMoneyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyList')), 'pressForMoneyList')
    },
    {
      path: '/pressForMoneyListByProject',
      name: 'pressForMoneyListByProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyListByProject')), 'pressForMoneyListByProject')
    },
    {
      path: '/addPressForMoney',
      name: 'addPressForMoney',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/addPressForMoney')), 'addPressForMoney')
    },
    {
      path: '/pressForMoneyRecord',
      name: 'pressForMoneyRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyRecord')), 'pressForMoneyRecord')
    },
    {
      path: '/pressForMoneyTimeRecords',
      name: 'pressForMoneyTimeRecords',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyTimeRecords')), 'pressForMoneyTimeRecords')
    },
    {
      path: '/pressForMoneyProjectList',
      name: 'pressForMoneyProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyProjectList')), 'pressForMoneyProjectList')
    },
    {
      path: '/pressForMoneyDetail',
      name: 'pressForMoneyDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyDetail')), 'pressForMoneyDetail')
    },
    {
      path: '/CommerceClause',
      name: 'CommerceClause',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/CommerceClause')), 'CommerceClause')
    },

    // {
    //   path: '/pressForDepositMoneyList',
    //   name: 'pressForDepositMoneyList',
    //   component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/PressForDepositMoney/pressForDepositMoneyList')), 'pressForDepositMoneyList')
    // },
    {
      path: '/pressForMoneyContractList',
      name: 'pressForMoneyContractList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/pressForMoneyContractList')), 'pressForMoneyContractList')
    },
    // {
    //   path: '/addPressForDepositMoney',
    //   name: 'addPressForDepositMoney',
    //   component: resolve => require.ensure([], () => resolve(require('@/public/home/pressForMoney/PressForDepositMoney/addPressForDepositMoney')), 'addPressForDepositMoney')
    // },
    {
      path: '/PKProjectlist',
      name: 'PKProjectlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKProjectlist')), 'PKProjectlist')
    },
    {
      path: '/PKPay',
      name: 'PKPay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKPay')), 'PKPay')
    },
    {
      path: '/myPKPay',
      name: 'myPKPay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/myPKPay')), 'myPKPay')
    },
    {
      path: '/PKResult',
      name: 'PKResult',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKResult')), 'PKResult')
    },
    {
      path: '/pKDetail',
      name: 'pKDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/pKDetail')), 'pKDetail')
    },
    {
      path: '/projectList',
      name: 'projectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/projectList')), 'projectList')
    },
    {
      path: '/proprietorListSBQ',
      name: 'proprietorListSBQ',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorListSBQ')), 'proprietorListSBQ')
    },
    {
      path: '/proprietorDetailSBQ',
      name: 'proprietorDetailSBQ',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorDetailSBQ')), 'proprietorDetailSBQ')
    },
    {
      path: '/proprietorReport',
      name: 'proprietorReport',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/surveyByQuestionnaire/proprietorReport')), 'proprietorReport')
    },
    {
      path: '/speechcraftList',
      name: 'speechcraftList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftList')), 'speechcraftList')
    },
    {
      path: '/speechcraftEdit',
      name: 'speechcraftEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftEdit')), 'speechcraftEdit')
    },
    {
      path: '/speechcraftAuditList',
      name: 'speechcraftAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftAuditList')), 'speechcraftAuditList')
    },
    {
      path: '/speechcraftAudit',
      name: 'speechcraftAudit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftAudit')), 'speechcraftAudit')
    },
    {
      path: '/processChildPage',
      name: 'processChildPage',
      component: resolve => require.ensure([], () => resolve(require('@/components/processChildPage')), 'processChildPage')
    },
    {
      path: '/processChildPageSpeekOrCL',
      name: 'processChildPageSpeekOrCL',
      component: resolve => require.ensure([], () => resolve(require('@/components/processChildPageSpeekOrCL')), 'processChildPageSpeekOrCL')
    },
    {
      path: '/contentPage',
      name: 'contentPage',
      component: resolve => require.ensure([], () => resolve(require('@/components/contentPage')), 'contentPage')
    },
    {
      path: '/callRecordStatistics',
      name: 'callRecordStatistics',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/callRecordStatistics')), 'callRecordStatistics')
    },
    {
      path: '/mortgageDocument',
      name: 'mortgageDocument',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocument')), 'mortgageDocument')
    },
    {
      path: '/mortgageDocumentDetail',
      name: 'mortgageDocumentDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocumentDetail')), 'mortgageDocumentDetail')
    },
    {
      path: '/mortgageDocumentRecord',
      name: 'mortgageDocumentRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mortgageDocument/mortgageDocumentRecord')), 'mortgageDocumentRecord')
    },
    {
      path: '/myScoreList',
      name: 'myScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/myScoreList/myScoreList')), 'myScoreList')
    },
    {
      path: '/myStaffViolationList',
      name: 'myStaffViolationList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/myScoreList/myStaffViolationList')), 'myStaffViolationList')
    },
    {
      path: '/serviceAgreementApplyList',
      name: 'serviceAgreementApplyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApplyList')), 'serviceAgreementApplyList')
    },
    {
      path: '/serviceAgreementApply',
      name: 'serviceAgreementApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApply')), 'serviceAgreementApply')
    },
    {
      path: '/serviceAgreementApplyRecordDetail',
      name: 'serviceAgreementApplyRecordDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApplyRecordDetail')), 'serviceAgreementApplyRecordDetail')
    },
    {
      path: '/serviceAgreementApplyRecordList',
      name: 'serviceAgreementApplyRecordList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApplyRecordList')), 'serviceAgreementApplyRecordList')
    },
    {
      path: '/serviceAgreementApplyAuditView',
      name: 'serviceAgreementApplyAuditView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApplyAuditView')), 'serviceAgreementApplyAuditView')
    },
    {
      path: '/serviceAgreementAuditList',
      name: 'serviceAgreementAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementAuditList')), 'serviceAgreementAuditList')
    },
    {
      path: '/serviceAgreementApplyAudit',
      name: 'serviceAgreementApplyAudit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/serviceAgreement/serviceAgreementApplyAudit')), 'serviceAgreementApplyAudit')
    },
    {
      path: '/mallGoodsList',
      name: 'mallGoodsList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/mallGoodsList')), 'mallGoodsList')
    },
    {
      path: '/scrapParkList',
      name: 'scrapParkList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/scrapParkList')), 'scrapParkList')
    },
    {
      path: '/tripartiteDocking',
      name: 'tripartiteDocking',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/tripartiteDocking/tripartiteDocking')), 'tripartiteDocking')
    },
    {
      path: '/tripartiteDockingFollowRecord',
      name: 'tripartiteDockingFollowRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/tripartiteDocking/tripartiteDockingFollowRecord')), 'tripartiteDockingFollowRecord')
    },
    {
      path: '/collectProjectList',
      name: 'collectProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/collectProjectList')), 'collectProjectList')
    },
    {
      path: '/addCollectProject',
      name: 'addCollectProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/addCollectProject')), 'addCollectProject')
    },
    {
      path: '/collectSelectProject',
      name: 'collectSelectProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/collectSelectProject')), 'collectSelectProject')
    },
    {
      path: '/newProject',
      name: 'newProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerCollect/newProject')), 'newProject')
    },
    {
      path: '/commercialTerms',
      name: 'commercialTerms',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/commercialTerms/commercialTerms')), 'commercialTerms')
    },
    {
      path: '/prkChangeList',
      name: 'prkChangeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingplace/prkChangeList')), 'prkChangeList')
    },
    {
      path: '/auditPKList',
      name: 'auditPKList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/auditPKList')), 'auditPKList')
    },
    {
      path: '/refundPK',
      name: 'refundPK',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/refundPK')), 'refundPK')
    },
    {
      path: '/auditAndView',
      name: 'auditAndView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/auditAndView')), 'auditAndView')
    },
    {
      path: '/refundPersonList',
      name: 'refundPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/refundPersonList')), 'refundPersonList')
    },
    {
      path: '/toDoList',
      name: 'toDoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/toDoList')), 'toDoList')
    },
    {
      path: '/simulationDetail',
      name: 'simulationDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/simulationDetail')), 'simulationDetail')
    },
    {
      path: '/simulationTable',
      name: 'simulationTable',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/simulationTable')), 'simulationTable')
    },
    {
      path: '/remainProblemsDetail',
      name: 'remainProblemsDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/remainProblemsDetail')), 'remainProblemsDetail')
    },
    {
      path: '/weekPlantList',
      name: 'weekPlantList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/weekPlant/weekPlantList')), 'weekPlantList')
    },
    {
      path: '/weekPlantDetail',
      name: 'weekPlantDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/weekPlant/weekPlantDetail')), 'weekPlantDetail')
    },
    {
      path: '/personnelTransferList',
      name: 'personnelTransferList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/personnelTransfer/personnelTransferList')), 'personnelTransferList')
    },
    {
      path: '/startTransfication',
      name: 'startTransfication',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/personnelTransfer/startTransfication')), 'startTransfication')
    },
    {
      path: '/transferDetails',
      name: 'transferDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/personnelTransfer/transferDetails')), 'transferDetails')
    },
    {
      path: '/todoTransferDetails',
      name: 'todoTransferDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/personnelTransfer/todoTransferDetails')), 'todoTransferDetails')
    },
    {
      path: '/saleStaffList',
      name: 'saleStaffList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/personnelTransfer/saleStaffList')), 'saleStaffList')
    },
    {
      path: '/supportProjectList',
      name: 'supportProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/supportProject/supportProjectList')), 'supportProjectList')
    },
    {
      path: '/supportProjectDetail',
      name: 'supportProjectDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/supportProject/supportProjectDetail')), 'supportProjectDetail')
    },
    {
      path: '/selectSupportProjectList',
      name: 'selectSupportProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/supportProject/selectSupportProjectList')), 'selectSupportProjectList')
    },
    {
      path: '/proprietorChatList',
      name: 'proprietorChatList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/weChart/proprietorChatList')), 'proprietorChatList')
    },
    {
      path: '/proprietorChatDetail',
      name: 'proprietorChatDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/weChart/proprietorChatDetail')), 'proprietorChatDetail')
    },
    {
      path: '/waitServiceLookOver',
      name: 'waitServiceLookOver',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/waiting/waitServiceLookOver')), 'waitServiceLookOver')
    },
    {
      path: '/PKDeduce',
      name: 'PKDeduce',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/PKDeduce')), 'PKDeduce')
    },
    {
      path: '/withdrawalTimeAuditList',
      name: 'withdrawalTimeAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/withdrawalTimeAudit/withdrawalTimeAuditList')), 'withdrawalTimeAuditList')
    },
    {
      path: '/withdrawalTimeAuditDetail',
      name: 'withdrawalTimeAuditDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/withdrawalTimeAudit/withdrawalTimeAuditDetail')), 'withdrawalTimeAuditDetail')
    },
    {
      path: '/inventoryRecordForPersonal',
      name: 'inventoryRecordForPersonal',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/inventoryPersonal/inventoryRecordForPersonal')), 'inventoryRecordForPersonal')
    },
    {
      path: '/InventoryForPersonal',
      name: 'InventoryForPersonal',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/inventoryPersonal/InventoryForPersonal')), 'InventoryForPersonal')
    },
    {
      path: '/lostForPersonal',
      name: 'lostForPersonal',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/inventoryPersonal/lostForPersonal')), 'lostForPersonal')
    },
    {
      path: '/draftScoreList',
      name: 'draftScoreList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/score/draftScoreList')), 'draftScoreList')
    },
    {
      path: '/studyMapPersonStep',
      name: 'studyMapPersonStep',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyMapPersonStep')), 'studyMapPersonStep')
    },
    {
      path: '/studyProcess',
      name: 'studyProcess',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyProcess')), 'studyProcess')
    },
    {
      path: '/offlineClassList',
      name: 'offlineClassList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassList')), 'offlineClassList')
    },
    {
      path: '/offlineClassDetail',
      name: 'offlineClassDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassDetail')), 'offlineClassDetail')
    },
    {
      path: '/selfpacedTrainingCourses',
      name: 'selfpacedTrainingCourses',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/selfpacedTraining/selfpacedTrainingCourses')), 'selfpacedTrainingCourses')
    },
    {
      path: '/addCourses',
      name: 'addCourses',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/selfpacedTraining/addCourses')), 'addCourses')
    },
    {
      path: '/allSelectPerson',
      name: 'allSelectPerson',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/selfpacedTraining/allSelectPerson')), 'allSelectPerson')
    },
    {
      path: '/selectScoreType',
      name: 'selectScoreType',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/selfpacedTraining/selectScoreType')), 'selectScoreType')
    },
    {
      path: '/lecturerList',
      name: 'lecturerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/lecturer/lecturerList')), 'lecturerList')
    },
    {
      path: '/lecturerDetail',
      name: 'lecturerDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/lecturer/lecturerDetail')), 'lecturerDetail')
    },
    {
      path: '/videoComplate',
      name: 'videoComplate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/videoComplate')), 'videoComplate')
    },
    {
      path: '/textbookDownloadList',
      name: 'textbookDownloadList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/textbookDownloadList')), 'textbookDownloadList')
    },
    {
      path: '/studyTest',
      name: 'studyTest',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyTest')), 'studyTest')
    },
    {
      path: '/aMapCommon',
      name: 'aMapCommon',
      component: resolve => require.ensure([], () => resolve(require('@/components/aMapCommon')), 'aMapCommon')
    },
    {
      path: '/practiseEveryDayList',
      name: 'practiseEveryDayList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/practiseEveryDay/practiseEveryDayList')), 'practiseEveryDayList')
    },
    {
      path: '/comonTest',
      name: 'comonTest',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/comonTest')), 'comonTest')
    },
    {
      path: '/statisticData',
      name: 'statisticData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/statisticData')), 'statisticData')
    },
    {
      path: '/passEveryWeekList',
      name: 'passEveryWeekList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/passEveryWeek/passEveryWeekList')), 'passEveryWeekList')
    },
    {
      path: '/passWeek',
      name: 'passWeek',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/passEveryWeek/passWeek')), 'passWeek')
    },
    {
      path: '/businessCollegeTaskList',
      name: 'businessCollegeTaskList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/businessCollegeTask/businessCollegeTaskList')), 'businessCollegeTaskList')
    },
    {
      path: '/studyForumList',
      name: 'studyForumList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumList')), 'studyForumList')
    },
    {
      path: '/changeSetByProject',
      name: 'changeSetByProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/changeSetByProject')), 'changeSetByProject')
    },
    {
      path: '/studyForumAddQuestion',
      name: 'studyForumAddQuestion',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAddQuestion')), 'studyForumAddQuestion')
    },
    {
      path: '/studyForumAddQuestionDetail',
      name: 'studyForumAddQuestionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAddQuestionDetail')), 'studyForumAddQuestionDetail')
    },
    {
      path: '/studyForumAnswerQuestion',
      name: 'studyForumAnswerQuestion',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyForum/studyForumAnswerQuestion')), 'studyForumAnswerQuestion')
    },
    {
      path: '/supportPersonList',
      name: 'supportPersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/supportProject/supportPersonList')), 'supportPersonList')
    },
    {
      path: '/supportProjectRecordList',
      name: 'supportProjectRecordList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/supportProject/supportProjectRecordList')), 'supportProjectRecordList')
    },
    {
      path: '/videoList',
      name: 'videoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/videoList/videoList')), 'videoList')
    },
    {
      path: '/allProjectAndHisTime',
      name: 'allProjectAndHisTime',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/allProjectAndHisTime')), 'allProjectAndHisTime')
    },
    {
      path: '/studyMapPersonStepNew',
      name: 'studyMapPersonStepNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyMapPersonStepNew')), 'studyMapPersonStepNew')
    },
    {
      path: '/myVideoList',
      name: 'myVideoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/videoList/myVideoList')), 'myVideoList')
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/videoList/videoDetail')), 'videoDetail')
    },
    {
      path: '/videoDetail2',
      name: 'videoDetail2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/videoList/videoDetail2')), 'videoDetail2')
    },
    {
      path: '/changeProject',
      name: 'changeProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/widget/changeProject')), 'changeProject')
    },
    {
      path: '/newComerMentoringList',
      name: 'newComerMentoringList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/newComerMentoring/newComerMentoringList')), 'newComerMentoringList')
    },
    {
      path: '/addComerMentoring',
      name: 'addComerMentoring',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/newComerMentoring/addComerMentoring')), 'addComerMentoring')
    },
    {
      path: '/newComerMentoringProcess',
      name: 'newComerMentoringProcess',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/newComerMentoring/newComerMentoringProcess')), 'newComerMentoringProcess')
    },
    {
      path: '/studyMapPersonStepNewEx',
      name: 'studyMapPersonStepNewEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/studyMap/studyMapPersonStepNewEx')), 'studyMapPersonStepNewEx')
    },
    {
      path: '/GuestFeeDetail',
      name: 'GuestFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/GuestFeeDetail')), 'GuestFeeDetail')
    },
    {
      path: '/speechcraftCollectList',
      name: 'speechcraftCollectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftCollectList')), 'speechcraftCollectList')
    },
    {
      path: '/speechcraftCollectEdit',
      name: 'speechcraftCollectEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/speechcraft/speechcraftCollectEdit')), 'speechcraftCollectEdit')
    },
    {
      path: '/merchantOrderList',
      name: 'merchantOrderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantOrderList')), 'merchantOrderList')
    },
    {
      path: '/merchantOrderAply',
      name: 'merchantOrderAply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantOrderAply')), 'merchantOrderAply')
    },
    {
      path: '/processDetail',
      name: 'processDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/processDetail')), 'processDetail')
    },
    {
      path: '/selectMerchantPage',
      name: 'selectMerchantPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/selectMerchantPage')), 'selectMerchantPage')
    },
    {
      path: '/merchantTypeFeeList',
      name: 'merchantTypeFeeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantTypeFeeList')), 'merchantTypeFeeList')
    },
    {
      path: '/selectPark',
      name: 'selectPark',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/selectPark')), 'selectPark')
    },
    {
      path: '/merchantOrderParkDetail',
      name: 'merchantOrderParkDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantOrderParkDetail')), 'merchantOrderParkDetail')
    },
    {
      path: '/merchantFlowPathView',
      name: 'merchantFlowPathView',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantFlowPathView')), 'merchantFlowPathView')
    },
    {
      path: '/merchantOrderAuditList',
      name: 'merchantOrderAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantOrderAuditList')), 'merchantOrderAuditList')
    },
    {
      path: '/merchantOrderAuditDetail',
      name: 'merchantOrderAuditDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/merchantOrderAuditDetail')), 'merchantOrderAuditDetail')
    },
    {
      path: '/infomationFeeCollection',
      name: 'infomationFeeCollection',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/infomationFee/infomationFeeCollection')), 'infomationFeeCollection')
    },
    {
      path: '/infomationTransfer',
      name: 'infomationTransfer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/infomationFee/infomationTransfer')), 'infomationTransfer')
    },
    {
      path: '/infomationTransferRecord',
      name: 'infomationTransferRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/infomationFee/infomationTransferRecord')), 'infomationTransferRecord')
    },
    {
      path: '/infoTransferRecordDetail',
      name: 'infoTransferRecordDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/infomationFee/infoTransferRecordDetail')), 'infoTransferRecordDetail')
    },
    {
      path: '/bankAccountBalance',
      name: 'bankAccountBalance',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bankAccountBalance/bankAccountBalance')), 'bankAccountBalance')
    },
    {
      path: '/newPower',
      name: 'newPower',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/newPower')), 'newPower')
    },
    {
      path: '/friendCircleTemplate',
      name: 'friendCircleTemplate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleTemplate/friendCircleTemplate')), 'friendCircleTemplate')
    },
    {
      path: '/friendCircleMaterial',
      name: 'friendCircleMaterial',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/friendCircleMaterial')), 'friendCircleMaterial')
    },
    {
      path: '/uploadFriendCircleMaterial',
      name: 'uploadFriendCircleMaterial',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/uploadFriendCircleMaterial')), 'uploadFriendCircleMaterial')
    },
    {
      path: '/previewFullImagePage',
      name: 'previewFullImagePage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/previewFullImagePage')), 'previewFullImagePage')
    },
    {
      path: '/uploadRecord',
      name: 'uploadRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/friendCircleMaterial/uploadRecord')), 'uploadRecord')
    },
    {
      path: '/selectPOS',
      name: 'selectPOS',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/selectPOS')), 'selectPOS')
    },
    {
      path: '/dataSummaryList',
      name: 'dataSummaryList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/dataSummary/dataSummaryList')), 'dataSummaryList')
    },
    {
      path: '/projectProcessEx',
      name: 'projectProcessEx',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/projectProcessEx')), 'projectProcessEx')
    },
    {
      path: '/processComponentsPage',
      name: 'processComponentsPage',
      component: resolve => require.ensure([], () => resolve(require('@/components/processComponentsPage')), 'processComponentsPage')
    },
    {
      path: '/projectProcessChildCL',
      name: 'projectProcessChildCL',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessChildCL')), 'projectProcessChildCL')
    },
    {
      path: '/projectProcessPersonPass',
      name: 'projectProcessPersonPass',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessPersonPass')), 'projectProcessPersonPass')
    },
    {
      path: '/projectProcessPersonDescription',
      name: 'projectProcessPersonDescription',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessPersonDescription')), 'projectProcessPersonDescription')
    },
    {
      path: '/projectProcessIsScan',
      name: 'projectProcessIsScan',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessIsScan')), 'projectProcessIsScan')
    },
    {
      path: '/processChildAdvertisement',
      name: 'processChildAdvertisement',
      component: resolve => require.ensure([], () => resolve(require('@/components/processChildAdvertisement')), 'processChildAdvertisement')
    },
    {
      path: '/lostOrReportedLossList',
      name: 'lostOrReportedLossList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lostOrReportedLoss/lostOrReportedLossList')), 'lostOrReportedLossList')
    },
    {
      path: '/lostOrReportedLossDetail',
      name: 'lostOrReportedLossDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lostOrReportedLoss/lostOrReportedLossDetail')), 'lostOrReportedLossDetail')
    },
    {
      path: '/projectProcessChildContent',
      name: 'projectProcessChildContent',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessChildContent')), 'projectProcessChildContent')
    },
    {
      path: '/goodsConsumingList',
      name: 'goodsConsumingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingList')), 'goodsConsumingList')
    },
    {
      path: '/goodsConsumingAdd',
      name: 'goodsConsumingAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingAdd')), 'goodsConsumingAdd')
    },
    {
      path: '/customerMaintenanceRecommendApply',
      name: 'customerMaintenanceRecommendApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerMaintenanceRecommend/customerMaintenanceRecommendApply')), 'customerMaintenanceRecommendApply')
    },
    {
      path: '/customerMaintenanceRecommendApplyChild',
      name: 'customerMaintenanceRecommendApplyChild',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerMaintenanceRecommend/customerMaintenanceRecommendApplyChild')), 'customerMaintenanceRecommendApplyChild')
    },
    {
      path: '/customerMaintenanceRecommendList',
      name: 'customerMaintenanceRecommendList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/customerMaintenanceRecommend/customerMaintenanceRecommendList')), 'customerMaintenanceRecommendList')
    },
    {
      path: '/customerMaintenanceRecommendSelect',
      name: 'customerMaintenanceRecommendSelect',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/customerMaintenanceRecommendSelect')), 'customerMaintenanceRecommendSelect')
    },
    {
      path: '/reserveTransitList',
      name: 'reserveTransitList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/reserveTransit/reserveTransitList')), 'reserveTransitList')
    },
    {
      path: '/reserveTransitAdd',
      name: 'reserveTransitAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/reserveTransit/reserveTransitAdd')), 'reserveTransitAdd')
    },
    {
      path: '/reserveTransitProjectInventory',
      name: 'reserveTransitProjectInventory',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/reserveTransit/reserveTransitProjectInventory')), 'reserveTransitProjectInventory')
    },
    {
      path: '/proCustomerServiceFeeList',
      name: 'proCustomerServiceFeeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/proCustomerServiceFeeList')), 'proCustomerServiceFeeList')
    },
    {
      path: '/proCustomerServiceFeeDetail',
      name: 'proCustomerServiceFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/proCustomerServiceFeeDetail')), 'proCustomerServiceFeeDetail')
    },
    {
      path: '/secondCustomerFeeDetail',
      name: 'secondCustomerFeeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proCustomerServiceFee/secondCustomerFeeDetail')), 'secondCustomerFeeDetail')
    },
    {
      path: '/inventorySecondCheckMove',
      name: 'inventorySecondCheckMove',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/check/inventorySecondCheckMove')), 'inventorySecondCheckMove')
    },
    {
      path: '/developPKlist',
      name: 'developPKlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developPK/developPKlist')), 'developPKlist')
    },
    {
      path: '/developPKDetail',
      name: 'developPKDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developPK/developPKDetail')), 'developPKDetail')
    },
    {
      path: '/developPKPay',
      name: 'developPKPay',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developPK/developPKPay')), 'developPKPay')
    },
    {
      path: '/inventoryleaveUnused',
      name: 'inventoryleaveUnused',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/inventoryleaveUnused')), 'inventoryleaveUnused')
    },
    {
      path: '/warehouseBoard',
      name: 'warehouseBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/warehouseBoard')), 'warehouseBoard')
    },
    {
      path: '/inventoryleaveUnusedList',
      name: 'inventoryleaveUnusedList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/warehouseBoardMag/inventoryleaveUnusedList')), 'inventoryleaveUnusedList')
    },
    {
      path: '/transitReserveListList',
      name: 'transitReserveListList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/warehouseBoardMag/transitReserveListList')), 'transitReserveListList')
    },
    {
      path: '/saleProcessBoard',
      name: 'saleProcessBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/saleProcess/saleProcessBoard')), 'saleProcessBoard')
    },
    {
      path: '/processChildForSalePage',
      name: 'processChildForSalePage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/saleProcess/processChildForSalePage')), 'processChildForSalePage')
    },
    {
      path: '/reserveTransitScanList',
      name: 'reserveTransitScanList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/reserveTransit/reserveTransitScanList')), 'reserveTransitScanList')
    },
    {
      path: '/receiptAcquittance',
      name: 'receiptAcquittance',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/process/receiptAcquittance')), 'receiptAcquittance')
    },
    {
      path: '/applyReplayMeeting',
      name: 'applyReplayMeeting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/applyReplayMeeting')), 'applyReplayMeeting')
    },
    {
      path: '/importantToDoList',
      name: 'importantToDoList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/importantToDoList')), 'importantToDoList')
    },
    {
      path: '/echartTest',
      name: 'echartTest',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerReplay/echartTest')), 'echartTest')
    },
    {
      path: '/managerReplayList',
      name: 'managerReplayList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerReplay/managerReplayList')), 'managerReplayList')
    },
    {
      path: '/managerReplayViewTab',
      name: 'managerReplayViewTab',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/managerReplay/managerReplayViewTab')), 'managerReplayViewTab')
    },
    {
      path: '/advertisingApplicationList',
      name: 'advertisingApplicationList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advertisingApplication/advertisingApplicationList')), 'advertisingApplicationList')
    },
    {
      path: '/advertisingApply',
      name: 'advertisingApply',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advertisingApplication/advertisingApply')), 'advertisingApply')
    },
    {
      path: '/advertisingTemps',
      name: 'advertisingTemps',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advertisingApplication/advertisingTemps')), 'advertisingTemps')
    },
     {
      path: '/selectPersonalProjectAndHisTime',
      name: 'selectPersonalProjectAndHisTime',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/advertisingApplication/selectPersonalProjectAndHisTime')), 'selectPersonalProjectAndHisTime')
    },
    {
      path: '/questionnaireInvestigation',
      name: 'questionnaireInvestigation',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/questionnaireInvestigation')), 'questionnaireInvestigation')
    },
    {
      path: '/personalInfo',
      name: 'personalInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/recruitmentRelated/personalInfo')), 'personalInfo')
    },
    {
      path: '/selfInstallList',
      name: 'selfInstallList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/selfInstall/selfInstallList')), 'selfInstallList')
    },
    {
      path: '/selfInstallInfo',
      name: 'selfInstallInfo',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/selfInstall/selfInstallInfo')), 'selfInstallInfo')
    },
    {
      path: '/selfSelectPark',
      name: 'selfSelectPark',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/merchantOrder/selfInstall/selfSelectPark')), 'selfSelectPark')
    },
    {
      path: '/changeTaskProjectList',
      name: 'changeTaskProjectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/changeTask/changeTaskProjectList')), 'changeTaskProjectList')
    },
    {
      path: '/changeProjectTask',
      name: 'changeProjectTask',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/changeTask/changeProjectTask')), 'changeProjectTask')
    },
    {
      path: '/operationManagment',
      name: 'operationManagment',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/operationManagement/operationManagement')), 'operationManagment')
    },
    {
      path: '/projectAndHisSaleData',
      name: 'projectAndHisSaleData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/operationManagement/projectAndHisSaleData')), 'projectAndHisSaleData')
    },
    {
      path: '/projectInfoManagement',
      name: 'projectInfoManagement',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/operationManagement/projectInfoManagement')), 'projectInfoManagement')
    },
    {
      path: '/goodsConsumingAuditList',
      name: 'goodsConsumingAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingAuditList')), 'goodsConsumingAuditList')
    },
    {
      path: '/goodsConsumingAudit',
      name: 'goodsConsumingAudit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/goodsConsuming/goodsConsumingAudit')), 'goodsConsumingAudit')
    },
    {
      path: '/todayFollowUpList',
      name: 'todayFollowUpList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/audit/todayFollowUpList')), 'todayFollowUpList')
    },
    {
      path: '/evaluateMaster',
      name: 'evaluateMaster',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/evaluateMaster/evaluateMaster')), 'evaluateMaster')
    },
    {
      path: '/evaluateRecord',
      name: 'evaluateRecord',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/evaluateMaster/evaluateRecord')), 'evaluateRecord')
    },
    {
      path: '/LKLPosOrderList',
      name: 'LKLPosOrderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/LKLPosOrderList')), 'LKLPosOrderList')
    },
    {
      path: '/weekPlantDetailNew',
      name: 'weekPlantDetailNew',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/weekPlant/weekPlantDetailNew')), 'weekPlantDetailNew')
    },
    {
      path: '/bestContributionResult',
      name: 'bestContributionResult',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bestContributionAward/bestContributionResult')), 'bestContributionResult')
    },
    {
      path: '/bestContributionVote',
      name: 'bestContributionVote',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/bestContributionAward/bestContributionVote')), 'bestContributionVote')
    },
    {
      path: '/posOrderList',
      name: 'posOrderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/posOrderManager/posOrderList')), 'posOrderList')
    },
    {
      path: '/collectionDetail',
      name: 'collectionDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/service/posOrderManager/collectionDetail')), 'collectionDetail')
    },
    {
      path: '/offlineClassRate',
      name: 'offlineClassRate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/offlineClass/offlineClassRate')), 'offlineClassRate')
    },
    {
      path: '/medalPage',
      name: 'medalPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/medal/medalPage')), 'medalPage')
    },
    {
      path: '/medalStatistic',
      name: 'medalStatistic',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/medal/medalStatistic')), 'medalStatistic')
    },
    {
      path: '/highQualityRecordingCountList',
      name: 'highQualityRecordingCountList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/highQualityRecordingCountList')), 'highQualityRecordingCountList')
    },
    {
      path: '/beeAIMsgList',
      name: 'beeAIMsgList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/beeAIMsgList')), 'beeAIMsgList')
    },
    {
      path: '/beeAIMsgDetail',
      name: 'beeAIMsgDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/beeAIMsgDetail')), 'beeAIMsgDetail')
    },
    {
      path: '/outPutPKlist',
      name: 'outPutPKlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/outPutPKlist')), 'outPutPKlist')
    },
    {
      path: '/projectAuditList',
      name: 'projectAuditList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/projectAudit/projectAuditList')), 'projectAuditList')
    },
    {
      path: '/projectAuditDetail',
      name: 'projectAuditDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/projectAudit/projectAuditDetail')), 'projectAuditDetail')
    },
    {
      path: '/projectProcessChildThree',
      name: 'projectProcessChildThree',
      component: resolve => require.ensure([], () => resolve(require('@/components/projectProcessChildThree')), 'projectProcessChildThree')
    },
    {
      path: '/senseOfWorthDetail',
      name: 'senseOfWorthDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/senseOfWorthDetail')), 'senseOfWorthDetail')
    },
    {
      path: '/beeStudyList',
      name: 'beeStudyList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/beeStudy/beeStudyList')), 'beeStudyList')
    },
    {
      path: '/beeStudyDetail',
      name: 'beeStudyDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/beeStudy/beeStudyDetail')), 'beeStudyDetail')
    },
    {
      path: '/beeStudyAnswer',
      name: 'beeStudyAnswer',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/businessCollege/beeStudy/beeStudyAnswer')), 'beeStudyAnswer')
    },
    {
      path: '/moreComment',
      name: 'moreComment',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/moreComment')), 'moreComment')
    },
    {
      path: '/paymentRefundList',
      name: 'paymentRefundList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/reimbursement/paymentRefundList')), 'paymentRefundList')
    },
    {
      path: '/meetingManageList',
      name: 'meetingManageList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/meetingManage/meetingManageList')), 'meetingManageList')
    },
    {
      path: '/meetingDetail',
      name: 'meetingDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/meetingManage/meetingDetail')), 'meetingDetail')
    },
    {
      path: '/referenceList',
      name: 'referenceList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/referenceManager/referenceList')), 'referenceList')
    },
    {
      path: '/referenceEdit',
      name: 'referenceEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/referenceManager/referenceEdit')), 'referenceEdit')
    },
    {
      path: '/referenceFeeList',
      name: 'referenceFeeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/referenceManager/referenceFeeList')), 'referenceFeeList')
    },
    {
      path: '/interviewList',
      name: 'interviewList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interview/interviewList')), 'interviewList')
    },
    {
      path: '/interviewDetail',
      name: 'interviewDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interview/interviewDetail')), 'interviewDetail')
    },
    {
      path: '/startInterview',
      name: 'startInterview',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/interview/startInterview')), 'startInterview')
    },
    {
      path: '/contractPKlist',
      name: 'contractPKlist',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/PK/contractPKlist')), 'contractPKlist')
    },
    {
      path: '/callCenterList',
      name: 'callCenterList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callCenterList')), 'callCenterList')
    },
    {
      path: '/callListData',
      name: 'callListData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callListData')), 'callListData')
    },
    {
      path: '/callListDetail',
      name: 'callListDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callListDetail')), 'callListDetail')
    },
    {
      path: '/callDetails',
      name: 'callDetails',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callDetails')), 'callDetails')
    },
    {
      path: '/callRecordList',
      name: 'callRecordList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/callCenter/callRecordList')), 'callRecordList')
    },
    {
      path: '/twoCodeView',
      name: 'twoCodeView',
      component: resolve => require.ensure([], () => resolve(require('@/components/twoCodeView')), 'twoCodeView')
    },
    {
      path: '/grantGiftList',
      name: 'grantGiftList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/grantGift/grantGiftList')), 'grantGiftList')
    },
    {
      path: '/grantGiftScan',
      name: 'grantGiftScan',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/grantGift/grantGiftScan')), 'grantGiftScan')
    },
    {
      path: '/grantGiftSelectList',
      name: 'grantGiftSelectList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/grantGift/grantGiftSelectList')), 'grantGiftSelectList')
    },
    {
      path: '/grantGiftScanShare',
      name: 'grantGiftScanShare',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/grantGift/grantGiftScanShare')), 'grantGiftScanShare')
    },
    {
      path: '/workOrderList',
      name: 'workOrderList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workOrder/workOrderList')), 'workOrderList')
    },
    {
      path: '/startWorkOrder',
      name: 'startWorkOrder',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/workOrder/startWorkOrder')), 'startWorkOrder')
    },
    {
      path: '/SWOTAdd',
      name: 'SWOTAdd',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/toDoList/SWOTAdd')), 'SWOTAdd')
    },
    {
      path: '/otherMoudle',
      name: 'otherMoudle',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/otherMoudle')), 'otherMoudle')
    },
    {
      path: '/depositWechartList',
      name: 'depositWechartList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/depositWechartList')), 'depositWechartList')
    },
    {
      path: '/depositWechartDetail',
      name: 'depositWechartDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/depositWechartDetail')), 'depositWechartDetail')
    },
    {
      path: '/waitSaleParkList',
      name: 'waitSaleParkList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/waitSaleParkList')), 'waitSaleParkList')
    },
    {
      path: '/allSelectStaff',
      name: 'allSelectStaff',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/mine/borrow/allSelectStaff')), 'allSelectStaff')
    },
    {
      path: '/appointmentViewingList',
      name: 'appointmentViewingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/appointmentViewingList')), 'appointmentViewingList')
    },
    {
      path: '/appointmentViewing',
      name: 'appointmentViewing',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/manager/appointmentViewing')), 'appointmentViewing')
    },
    {
      path: '/actionWXList',
      name: 'actionWXList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/actionWXList')), 'actionWXList')
    },
    {
      path: '/liveBroadcast',
      name: 'liveBroadcast',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/liveBroadcast')), 'liveBroadcast')
    },
    {
      path: '/liveBroadcastCreate',
      name: 'liveBroadcastCreate',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/liveBroadcastCreate')), 'liveBroadcastCreate')
    },
    {
      path: '/liveStreamAssistant',
      name: 'liveStreamAssistant',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/liveStreamAssistant')), 'liveStreamAssistant')
    },
    {
      path: '/lockWxParkList',
      name: 'lockWxParkList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lockWxPark/lockWxParkList')), 'lockWxParkList')
    },
    {
      path: '/lockWxParkDetail',
      name: 'lockWxParkDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/lockWxPark/lockWxParkDetail')), 'lockWxParkDetail')
    },
    {
      path: '/moveCarList',
      name: 'moveCarList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/moveCarManage/moveCarList')), 'moveCarList')
    },
    {
      path: '/moveCarDetail',
      name: 'moveCarDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/moveCarManage/moveCarDetail')), 'moveCarDetail')
    },
    {
      path: '/distributionSaleList',
      name: 'distributionSaleList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/distributionManage/distributionSaleList')), 'distributionSaleList')
    },
    {
      path: '/distributionSaleDetail',
      name: 'distributionSaleDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/distributionManage/distributionSaleDetail')), 'distributionSaleDetail')
    },
    {
      path: '/addRegionalPolicies',
      name: 'addRegionalPolicies',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/commercialTerms/addRegionalPolicies')), 'addRegionalPolicies')
    },
    {
      path: '/summaryTable5',
      name: 'summaryTable5',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/summaryTable5')), 'summaryTable5')
    },
    {
      path: '/updateSummaryTable2',
      name: 'updateSummaryTable2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/updateSummaryTable2')), 'updateSummaryTable2')
    },
    {
      path: '/setFiveYearSaleTeam',
      name: 'setFiveYearSaleTeam',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/setFiveYearSaleTeam')), 'setFiveYearSaleTeam')
    },
    {
      path: '/punchClockSetting',
      name: 'punchClockSetting',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/checkWorkAttendance/punchClockSetting')), 'punchClockSetting')
    },
    {
      path: '/projectStall2',
      name: 'projectStall2',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectStall2')), 'projectStall2')
    },
    {
      path: '/projectStallParkType',
      name: 'projectStallParkType',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/projectStallParkType')), 'projectStallParkType')
    },
    {
      path: '/worthMap',
      name: 'worthMap',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/worthMap')), 'worthMap')
    },
    {
      path: '/analysisReport',
      name: 'analysisReport',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/proprietor/analysisReport')), 'analysisReport')
    },
    {
      path: '/generalSecondLevelBoard',
      name: 'generalSecondLevelBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/generalSecondLevelBoard')), 'generalSecondLevelBoard')
    },
    {
      path: '/marketingManageList',
      name: 'marketingManageList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/marketingManageList')), 'marketingManageList')
    },
    {
      path: '/marketingManagePersonList',
      name: 'marketingManagePersonList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/marketingManagePersonList')), 'marketingManagePersonList')
    },
     {
      path: '/miniProgramData',
      name: 'miniProgramData',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/miniProgramData')), 'miniProgramData')
    },
     {
      path: '/dataBoard',
      name: 'dataBoard',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/dataBoard')), 'dataBoard')
    },
    {
      path: '/testPage',
      name: 'testPage',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/testPage')), 'testPage')
    },
    {
      path: '/voteActivityList',
      name: 'voteActivityList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/voteActivityList')), 'voteActivityList')
    },
    {
      path: '/voteActivityDetail',
      name: 'voteActivityDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/voteActivityDetail')), 'voteActivityDetail')
    },
    {
      path: '/selectVoteObj',
      name: 'selectVoteObj',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/minSysRelation/selectVoteObj')), 'selectVoteObj')
    },
    {
      path: '/developerReceptionList',
      name: 'developerReceptionList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerReception/developerReceptionList')), 'developerReceptionList')
    },
    {
      path: '/developerReceptionEdit',
      name: 'developerReceptionEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/developerReception/developerReceptionEdit')), 'developerReceptionEdit')
    },
     {
      path: '/helpSmart',
      name: 'helpSmart',
      component: resolve => require.ensure([], () => resolve(require('@/components/helpSmart')), 'helpSmart')
    },
    {
      path: '/propertyViewingList',
      name: 'propertyViewingList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyViewing/propertyViewingList')), 'propertyViewingList')
    },
    {
      path: '/propertyViewingEdit',
      name: 'propertyViewingEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyViewing/propertyViewingEdit')), 'propertyViewingEdit')
    },
     {
      path: '/analyseAudioAgent',
      name: 'analyseAudioAgent',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyViewing/analyseAudioAgent')), 'analyseAudioAgent')
    },
     {
      path: '/chatRecordingAudio',
      name: 'chatRecordingAudio',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyViewing/chatRecordingAudio')), 'chatRecordingAudio')
    },
    {
      path: '/projectTeamInfoAndManagerList',
      name: 'projectTeamInfoAndManagerList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/propertyViewing/projectTeamInfoAndManagerList')), 'projectTeamInfoAndManagerList')
    },
    {
      path: '/processActiveList',
      name: 'processActiveList',
      component: resolve => require.ensure([], () => resolve(require('@/components/processActiveList')), 'processActiveList')
    },
    {
      path: '/outputValueMap',
      name: 'outputValueMap',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/project/outputValueMap')), 'outputValueMap')
    },
    {
      path: '/actorClockInList',
      name: 'actorClockInList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/actorClockIn/actorClockInList')), 'actorClockInList')
    },
    {
      path: '/startInvitateActor',
      name: 'startInvitateActor',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/actorClockIn/startInvitateActor')), 'startInvitateActor')
    },
    {
      path: '/selectProject',
      name: 'selectProject',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/actorClockIn/selectProject')), 'selectProject')
    },
    {
      path: '/projectTransferNoticeList',
      name: 'projectTransferNoticeList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/projectTransferNotice/projectTransferNoticeList')), 'projectTransferNoticeList')
    },
    {
      path: '/projectTransferNoticeDetail',
      name: 'projectTransferNoticeDetail',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/projectTransferNotice/projectTransferNoticeDetail')), 'projectTransferNoticeDetail')
    },
    {
      path: '/parkingRentalList',
      name: 'parkingRentalList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/parkingRental/parkingRentalList')), 'parkingRentalList')
    },
    {
      path: '/eleReceiptList',
      name: 'eleReceiptList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/electronicReceipt/eleReceiptList')), 'eleReceiptList')
    },
    {
      path: '/eleReceiptEdit',
      name: 'eleReceiptEdit',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/electronicReceipt/eleReceiptEdit')), 'eleReceiptEdit')
    },
    {
      path: '/commonText',
      name: 'commonText',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/commonText')), 'commonText')
    },
    {
      path: '/agentList',
      name: 'agentList',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/agentList')), 'agentList')
    },
    {
      path: '/agentIframe',
      name: 'agentIframe',
      component: resolve => require.ensure([], () => resolve(require('@/public/home/msg/agentIframe')), 'agentIframe')
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js